<div class="heading">
  <div class="d-flex justify-content-between align-items-center">
    <div class="title d-flex align-items-center" style="z-index: 9999; gap: 16px">
      <h2 class="m-0">{{'soan_thao' | translate}}</h2>
      <app-select-language-config [isAdmin]="true"></app-select-language-config>
    </div>
    <span style="cursor:pointer; color: red" nz-icon nzType="close" nzTheme="outline" (click)="close()">
    </span>
  </div>

  <div class="config-font">
    <p class="title">{{'cap_nhat_noi_dung_hien_thi' | translate}}</p>

    <!-- KHÔNG BẬT Nội dung khác nhau cho từng thiết bị -->
    <form *ngIf="!data?.staticdata.is_different_content_for_devices" [formGroup]="dataContent">
      <div class="row">
        <div class="col-lg content-container">
          <ckeditor *ngIf="EDITOR" [formControl]="getFormControl('content_' + functionService.languageTempCode)" 
          [editor]="EDITOR" (ready)="onReady($event)" [config]="functionService.CKEDITORConfig">
          </ckeditor>
        </div>
      </div>
      <!-- Nút lưu -->
      <div class="btn-save">
        <button class="btn-save__content" (click)="updateStaticData()">{{'luu_thay_doi' | translate}}</button>
      </div>
    </form>

    <!-- CÓ BẬT Nội dung khác nhau cho từng thiết bị -->
    <!-- Tab thiết bị -->
    <nz-tabset *ngIf="data?.staticdata.is_different_content_for_devices" [nzSelectedIndex]="selectedIndex" (nzSelectChange)="changeTabs($event)">
      <nz-tab nzTitle="Desktop" *ngIf="!data.desktop_hidden">
        <ng-container *ngTemplateOutlet="templateConfig;"></ng-container>
      </nz-tab>
      <nz-tab nzTitle="Tablet ngang" *ngIf="!data.tablet_landscape_hidden">
        <ng-container *ngTemplateOutlet="templateConfig;"></ng-container>
      </nz-tab>
      <nz-tab nzTitle="Tablet dọc" *ngIf="!data.tablet_portrait_hidden">
        <ng-container *ngTemplateOutlet="templateConfig;"></ng-container>
      </nz-tab>
      <nz-tab nzTitle="Mobile ngang" *ngIf="!data.mobile_landscape_hidden">
        <ng-container *ngTemplateOutlet="templateConfig;"></ng-container>
      </nz-tab>
      <nz-tab nzTitle="Mobile dọc" *ngIf="!data.mobile_portrait_hidden">
        <ng-container *ngTemplateOutlet="templateConfig;"></ng-container>
      </nz-tab>
    </nz-tabset>

    <!-- Phần nội dung bên trong tab -->
    <ng-template #templateConfig>
      <form [formGroup]="dataContent">
        <div class="row">
          <div class="col-lg content-container">
            <ckeditor *ngIf="EDITOR" [formControl]="getFormControl(device + '_content_' + functionService.languageTempCode)"
            [editor]="EDITOR" (ready)="onReady($event)" [config]="functionService.CKEDITORConfig">
            </ckeditor>
          </div>
        </div>
        <!-- Nút lưu -->
        <div class="btn-save">
          <button class="btn-save__content" (click)="updateStaticData()">{{'luu_thay_doi' | translate}}</button>
        </div>
      </form>
    </ng-template>
  </div>
</div>

